import { $Q, $Qll } from "../../utils/query-selector";
import { config } from "../slider-defer";

/**
 * Listen when a product was added to wishlist to filtered and render carousel
 * @param {function} cb - Callback
 * @returns
 */
function observerWishlist(cb) {
  const wishlistReference = $Q('.account__wishlist-reference')

  if (!wishlistReference) return

  const observer = new MutationObserver((mutationList, observer) => {
    mutationList.forEach(({ addedNodes }) => {
      if (addedNodes.length) {
        cb()
      }
    })
  })

  observer.observe(wishlistReference, {
    attributes: true,
    childList: true
  })
}

/**
 * Insert elements filtered
 * @param {array} productSlides - products without be selected
 * @returns
 */
function renderElements(productSlides) {
  const wrapper = $Q('#slider_js-collection .swiper-wrapper')

  if (!wrapper) return

  wrapper.innerHTML = ''
  wrapper.append(...productSlides)
}

/**
 * Filter element without be selected
 * @see renderElements
 * @returns null - stop called
 */
function mapItemsSelected() {
  const carousel = $Qll('#slider_js-collection .swiper-slide')

  if (!carousel) return

  const filtered = carousel.filter((product) => {
    const added = $Q('.wk-button--add', product)

    if (added) {
      return added
    }
  })

  if (!filtered.length) return

  renderElements(filtered)
  config(`#slider_js-collection`);
}

/**
 * Function base to remove element already selected in a wishlist
 * @see observerWishlist
 * @see mapItemsSelected
 */
export function removeSelected() {
  observerWishlist(() => {
    mapItemsSelected()
  })
}
